<template><div><h1 id="who-is-this-documentation-for" tabindex="-1"><a class="header-anchor" href="#who-is-this-documentation-for"><span>Who is this documentation for?</span></a></h1>
<p>The chrultrabook documentation is for people who are looking to replace ChromeOS with a different OS. This site contains information on how to replace the OS on your device, along with any extra info you may need to get the most out of your device.</p>
<hr>
<p>Because of the technical nature of this process, you are expected to have some technical background info and troubleshooting skills. <strong>This is NOT a one click procedure.</strong></p>
</div></template>


